
































import Vue from 'vue'

interface ComponentData {
  loading: boolean
  inSaveProgress: boolean
  valid: boolean
  activeTab: number

  currencyList: any[]
  Bezeichnung: any | null
  IBAN: any | null
  SWIFTBIC: any | null
}

export default Vue.extend({
  name: 'ProfitCenterBank',

  components: {},

  props: {
    profitCenterId: Number,
    isCreate: Boolean,
    isUpdate: Boolean
  },

  data (): ComponentData {
    return {
      loading: false,
      inSaveProgress: false,
      valid: false,
      activeTab: 0,

      currencyList: [],
      Bezeichnung: null,
      IBAN: null,
      SWIFTBIC: null,
    }
  },

  watch: {
    profitCenterId (newVal: number): void {
      if(newVal && newVal !== 0) {

      }
    }
  },

  computed: {

  },

  methods: {
    onSaveClick (): void {

    },

    onCancelClick (): void {
      this.$emit('cancel')
    }
  },

  mounted () {
    this.currencyList = [
      {id: 1, label: 'CHF'},
      {id: 2, label: 'EUR'},
      {id: 3, label: 'USD'}
    ]
  }

})
